<template>
  <div class="container-fluid full-width-page-wrapper">
    <div class="row">
      <div class="col my-auto">
        <h3 class="page-title">My Reference letters</h3>
      </div>
    </div>

    <tabs v-model="currentTab" :tabItems="TAB_ITEMS" defaultTab="waiting_for_letter">
      <template slot="tab-content">
        <ReferencesTable :references="references"/>
      </template>
    </tabs>

  </div>
</template>

<script>
import References from '@/services/Api/Awards/References';
import ReferencesTable from '@/views/areas/awards/references/partials/ReferencesTable.vue';
import Tabs from '@/views/components/Tabs.vue';
import { AwardsReferencesTabs } from '@/services/tabs';

export default {
  name: 'Awards',
  components: { Tabs, ReferencesTable },
  data() {
    return {
      currentTab: 'waiting_for_letter',
      TAB_ITEMS: [],
      references: [],
    };
  },
  created() {
    this.TAB_ITEMS = AwardsReferencesTabs;
    this.fetchReferences();
  },
  methods: {
    fetchReferences() {
      const params = {
        relations: [
          'affiliate',
          'nomination.award',
          'nomination.affiliate',
          'nomination.nominee',
        ],
      };

      References.all(params).then((response) => {
        this.references = response.data.data.filter((reference) => {
           if (this.section === 'waiting_for_letter') {
             return reference.status.id === 'waiting';
           }

            return reference.status.id !== 'waiting';
        });
      });
    },
  },
  computed: {
    section() {
      return this.$route.query.section;
    },
  },
  watch: {
    section() {
      this.fetchReferences();
    },
  },
};
</script>

<style scoped lang='scss'>
@import '@/assets/styles/base/_variables.scss';
@import '@/assets/styles/base/_mixins.scss';
</style>
